import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initCookieManager } from "./lib/cookieManager";

// Inizializza il cookie manager prima di renderizzare l'app
initCookieManager();

// Console copyright message (rimosso in produzione da esbuild)
if (import.meta.env.DEV) {
  console.log(
    "%c© manuelgaleone.it",
    "color: #d97706; font-size: 16px; font-weight: bold; padding: 4px 8px; background: #1c1917; border-radius: 4px;"
  );
  console.log(
    "%cDeveloped by Manuel (Pio) Galeone",
    "color: #78716c; font-size: 12px; padding: 2px 8px;"
  );
}

createRoot(document.getElementById("root")!).render(<App />);
